import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";

import Loader from "../../components/loader/Loader";
import {
  DeleteIcon,
  EditIcon,
} from "../../components/svgIcons/SvgIcons";
import { TableComponent } from "../../components/table/TableComponent";
import { DeleteModal, FormatDate } from "../../helpers/Util";
import {
  currentPageCount,
  currentPageSelector,
} from "../../redux/ducks/pagination.duck";
import {
  DeleteCategory,
  GetCategories,
} from "../../services/CategoriesServices";
import Card from "../../wrapper/Card";

const Categories = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [loader, setLoader] = useState<boolean>(true);
  const currentPage = useSelector(currentPageSelector);
  const [deleteId, setDeleteId] = useState<string | number>("");
  const [categoriesData, setCategoriesData] = useState<{
    data: [];
    totalPage: number;
    totalCount: number;
  }>({
    data: [],
    totalPage: 0,
    totalCount: 0,
  });

  useEffect(() => {
    dispatch(currentPageCount(1));
  }, []);

  useEffect(() => {
    GetAllCategories(queryString);
  }, [currentPage]);

  let queryString = `?page=${currentPage}&limit=${10}&parentCategory=true`;

  const columnData = [
    {
      header: "Image",
      name: "image",
      className: "",
      commonClass: "",
      cell: (props:{image:string}) => {
        return <img className="h-14 w-14"  alt={`${process.env.REACT_APP_API_URL}${props?.image}`} 
        src={`${process.env.REACT_APP_API_URL}${props?.image}`} />;
      },
    },
    {
      header: "Name",
      name: "name",
      className: "",
      commonClass: "",
      option: {
        sort: true,
      },
    },
    {
      header: "Created At",
      name: "createdAt",
      className: "",
      commonClass: "",
      option: {
        sort: true,
      },
      cell: (props: { createdAt: string;  }) => {
        return (
      FormatDate(props.createdAt)
        );
      },
    },
    {
      header: "Action",
      commonClass: "right_action",
      cell: (props: { id: string; status: string }) => {
        return (
          <>
            <EditIcon
              onClick={() => {
                navigate(`/categories/edit/${props.id}`,{state:{...props}});
              }}
            />
            {deleteId !== props.id ? (
              <DeleteIcon
                onClick={() => DeleteModal(props.id, deleteCategory)}
              />
            ) : (
              <Loader size="w-5 h-5 mb-3 ml-2 text-[#E17446]" />
            )}
          </>
        );
      },
    },
  ];

  async function deleteCategory(id: string) {
    setDeleteId(id);
    const response = await DeleteCategory(id);
    const { response_type, message } = response.data;
    if (response_type === "success") {
      toast(message);
      await GetAllCategories(queryString);
    } else {
      setDeleteId("");
      toast.error(message);
    }
  }

  async function GetAllCategories(query: string) {
    setDeleteId("");
    deleteId !== "" && setLoader(true);

    const response = await GetCategories(query);
    if (response?.data?.responseData) {
      if (response?.data?.responseData?.lastPage === 1) {
        dispatch(currentPageCount(1));
      }
      setCategoriesData({
        data: response?.data?.responseData?.data,
        totalCount: response.data.responseData.count,
        totalPage: response.data.responseData.lastPage,
      });
    }
    setLoader(false);
  }

  async function filterApiCallback(query: string) {
    setLoader(true);
    const response = await GetCategories(query + `&parentCategory=true`);
    if (response?.data?.responseData) {
      setCategoriesData({
        data: response?.data?.responseData.data,
        totalCount: response.data.responseData.count,
        totalPage: response.data.responseData.lastPage,
      });
    }
    setLoader(false);
  }

  return (
    
      <div className="gro_cat_listing">
        <Card
          title=""
          isButton={true}
          buttonText={"Add Project Category"}
          link="categories"
        >
          <TableComponent
            tableHeading={"Project Categories"}
            bodyData={categoriesData?.data}
            headerData={columnData}
            dataPerPage={10}
            totalPage={categoriesData.totalPage}
            search={true}
            paginationApiCb={filterApiCallback}
            pagination={true}
            filter={false}
            loader={loader}
          />
        </Card>
      </div>
  
  );
};

export default Categories;
